import { render } from "./xtx-city.vue?vue&type=template&id=136e6c6d&scoped=true"
import script from "./xtx-city.vue?vue&type=script&lang=js"
export * from "./xtx-city.vue?vue&type=script&lang=js"

import "./xtx-city.vue?vue&type=style&index=0&id=136e6c6d&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\lot\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136e6c6d"]])

export default __exports__